import { Component, OnInit, inject } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import { RouterOutlet } from '@angular/router';
import { AlertComponent } from '@uiViews/alert/alert.component';
import { Brands } from '@domainInterfaces/views/hide-for-brand.interface';
import { IdleService } from '@infraestructure/drive-adapter/services/idle.service';
import { Brand } from '@domain/enums/brand/brand.enum';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, AlertComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private _titleService = inject(Title);
  private _router = inject(Router);
  private _activatedRoute = inject(ActivatedRoute);
  private _idleService = inject(IdleService);
  private _brand!: string;

  ngOnInit() {
    this._brand = Brands[window.location.host];
    this.updateTitleOnNavigation();
    this.setFavIcon();
  }

  updateTitleOnNavigation() {
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this._activatedRoute),
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        mergeMap((route) => route.data)
      )
      .subscribe((data) => {
        const pageTitle = data['title'] || 'Member Portal';
        const brandName = this._brand ?? 'PFI Verify';
        this._titleService.setTitle(`${brandName} - ${pageTitle}`);
      });
  }

  setFavIcon() {
    const favIcon: HTMLLinkElement = document.querySelector('#fav-icon')!;
    switch (this._brand?.replaceAll(" ", "")) {
      case Brand[Brand.Financeify]:
        favIcon.href = 'assets/images/favicons/financeify.ico';
        break;
      default:
        favIcon.href = 'assets/images/favicons/pfmverify.ico';
        break;
    }
  }
}
